import { NavBar } from "antd-mobile";
export default NavBar;
